import { render, staticRenderFns } from "./Inspirational.vue?vue&type=template&id=b52dccaa&"
import script from "./Inspirational.vue?vue&type=script&lang=js&"
export * from "./Inspirational.vue?vue&type=script&lang=js&"
import style0 from "./Inspirational.vue?vue&type=style&index=0&id=b52dccaa&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports